"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReflexShotAbilityHandler = exports.ReflexShotActorAbilityFactory = exports.ReflexShotAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ReflexShotAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ReflexShot;
        this.__typeName = "ReflexShot";
    }
}
exports.ReflexShotAbilityArgs = ReflexShotAbilityArgs;
let ReflexShotActorAbilityFactory = class ReflexShotActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ReflexShot", "OneEnemies", 0);
    }
};
ReflexShotActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ReflexShot")
], ReflexShotActorAbilityFactory);
exports.ReflexShotActorAbilityFactory = ReflexShotActorAbilityFactory;
let ReflexShotAbilityHandler = class ReflexShotAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            sequence,
            targets: [
                {
                    targetId,
                    jitter: 0,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                    ],
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Permanent,
                            effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Toughness, 1)
                        },
                    ]
                }
            ]
        });
    }
};
ReflexShotAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ReflexShot)
], ReflexShotAbilityHandler);
exports.ReflexShotAbilityHandler = ReflexShotAbilityHandler;
